import { render, staticRenderFns } from "./ResolutionLostInfo.vue?vue&type=template&id=d35a3ee6&scoped=true&"
import script from "./ResolutionLostInfo.vue?vue&type=script&lang=js&"
export * from "./ResolutionLostInfo.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionLostInfo.vue?vue&type=style&index=0&id=d35a3ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35a3ee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d35a3ee6')) {
      api.createRecord('d35a3ee6', component.options)
    } else {
      api.reload('d35a3ee6', component.options)
    }
    module.hot.accept("./ResolutionLostInfo.vue?vue&type=template&id=d35a3ee6&scoped=true&", function () {
      api.rerender('d35a3ee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/pages/signIn/common/Text/ResolutionLostInfo.vue"
export default component.exports